(function() {

  'use strict';
  $(function() {

    $( '[data-fancybox]' ).fancybox({
      caption : function( instance, item ) {
        return $(this).find('figcaption').html();
      }
    });

    $('.lente-img').on('click', function() {
      $('#primaImg').trigger('click');
    });

    $('.link-galleria').on('click', function(event) {
      event.preventDefault();
      $('#primaImg').trigger('click');
    });

    var slider_immagini_progetto = $('.slider-immagini-progetto');
      
    slider_immagini_progetto.owlCarousel({
      loop:false,
      interval: 2000,
      pause: "false",
      smartSpeed: 1000,
      items:1,
      dots: false,
      autoplay:false,
      autoplayTimeout:5000,
      autoplayHoverPause:false,
      nav: false,
      margin: 0,
      responsiveClass:false
    });

  });

}());
